<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.title"
        placeholder="活动标题"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.type"
        placeholder="抽奖模式"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in RAFFLE_ACTIVITY_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in RAFFLE_ACTIVITY_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
    </div>

    <div class="total-container">
      <div>抽奖活动数量: {{ total }}</div>
      <div>
        奖池余额: {{ totalDrawn.amount || 0 }} &nbsp;&nbsp;奖池累计余额:
        {{ totalDrawn.totalAmount || 0 }}
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column label="商户编号" align="center" prop="mchId"></el-table-column>
      <el-table-column label="活动标题" align="center" prop="title"></el-table-column>
      <el-table-column label="抽奖模式" align="type">
        <template slot-scope="scope">
          {{ getValue(RAFFLE_ACTIVITY_TYPE, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="status">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.status === 1 ? 'success' : 'danger'" effect="dark">
            {{ getValue(RAFFLE_ACTIVITY_STATUS, scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="创建时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            >编辑</el-button
          >
          <el-popconfirm
            confirm-button-text="好的"
            cancel-button-text="不用了"
            icon="el-icon-info"
            icon-color="red"
            title="确定修改该活动状态吗？"
            @confirm="checkActivityStatus(scope.row)"
            style="margin: 0 8px;"
          >
            <el-button slot="reference" type="warning" size="mini">切换活动状态</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogType]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="活动标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="抽奖模式" prop="type">
          <el-select
            v-model="form.type"
            placeholder="请选择"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in RAFFLE_ACTIVITY_TYPE"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="活动奖品">
          <div>
            <!--设置奖品-->
            <div>
              <div v-for="(item, index) in form.prizeJson" :key="index" class="prizeJson_warp">
                <el-select
                  v-model="item.id"
                  placeholder="奖品"
                  style="width: 30%"
                  class="filter-item"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in prizesList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
                <!--                <el-input-->
                <!--                  v-model="item.num"-->
                <!--                  placeholder="奖品数量"-->
                <!--                  style="width: 20%"-->
                <!--                  size="small"-->
                <!--                />-->
                <el-input
                  v-model="item.rate"
                  placeholder="中奖概率"
                  style="width: 20%"
                  size="small"
                />

                <el-select
                  v-model="item.status"
                  placeholder="状态"
                  style="width: 30%"
                  class="filter-item"
                  clearable
                  size="small"
                >
                  <el-option
                    v-for="item in RAFFLE_STATUS"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>

                <el-button @click="deletePrizes(index)" size="mini" type="danger" round
                  >删除</el-button
                >
              </div>
            </div>
            <el-button @click="addPrizes" style="width: 100%;" size="small">添加奖品</el-button>
          </div>
        </el-form-item>
        <el-form-item label="活动主题背景图" prop="themeUrl">
          <UploadList
            :typeProps="UPLOAD_IMG_TYPE.BRAND"
            @valueFunc="getImgsValueFunc"
            paramsType="themeUrl"
            :model="form.themeUrl"
            :maxCount="1"
          />
        </el-form-item>
        <el-form-item label="活动规则" prop="rule">
          <quill-editor
            v-model="form.rule"
            class="content_warp"
            ref="myQuillEditor"
            :options="editorOption"
          ></quill-editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {}, '')">取消</el-button>
        <el-button type="primary" @click="saveAddOrEditData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRaffleActivityList,
  editRaffleActivity,
  updateRaffleActivityStatus,
  getPrizesList,
  getRafflePoolBalance
} from "@/api/raffle.js";
import { formatApiDate, getFileName } from "@/utils/utils";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  UPLOAD_IMG_TYPE,
  RAFFLE_ACTIVITY_TYPE,
  RAFFLE_ACTIVITY_STATUS,
  RAFFLE_STATUS
} from "@/utils/enumUtile";
import UploadList from "@/views/components/uploadList";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    RAFFLE_ACTIVITY_TYPE() {
      return RAFFLE_ACTIVITY_TYPE;
    },
    RAFFLE_ACTIVITY_STATUS() {
      return RAFFLE_ACTIVITY_STATUS;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    RAFFLE_STATUS() {
      return RAFFLE_STATUS;
    }
  },
  components: { UploadList, quillEditor },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        title: null, // 关键字
        status: null, // 状态：1-开启，2-关闭
        type: null
      },
      dialogFormVisible: false,
      dialogType: "",
      rules: {
        type: [{ required: true, message: "抽奖模式不能为空", trigger: "change" }],
        title: [{ required: true, message: "活动标题不能为空", trigger: "change" }]
      },
      form: {
        id: 0,
        type: null, //抽奖模式
        title: null,
        themeUrl: null, // 活动主题背景图
        prizeJson: [], // 奖品数组
        rule: null // 活动规则说明
      },
      btnLoading: false,
      prizesList: [], // 奖品列表
      editorOption: {
        placeholder: "请输入",
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rt1" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["link", "image", "video"],
              ["clean"]
            ],
            handlers: {
              //此处是图片上传时候需要使用到的
              image: value => {
                if (value) {
                  // 点击图片
                  document.querySelector(".uploadFile input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              upload: value => {
                if (value) {
                  // 点击图片
                  document.querySelector(".uploadFile input").click();
                }
              }
            }
          },
          clipboard: {
            // 剪切板事件
            matchers: [
              ["img", this.handlePasteImg] // 匹配图片剪切板
            ]
          }
        }
      },
      totalDrawn: {
        amount: 0,
        totalAmount: 0
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    // 查询奖励池余额
    onGetRafflePoolBalance() {
      getRafflePoolBalance().then(response => {
        console.log("查询奖励池余额", response);
        this.totalDrawn = response.data;
      });
    },

    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getRaffleActivityList(params)
        .then(response => {
          this.onGetRafflePoolBalance();
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    /**
     * 切换状态
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      if (status && type === "UPDATE") {
        this.form.id = editObj.id;
        this.form.type = editObj.type;
        this.form.title = editObj.title;
        this.form.rule = editObj.ruleDescr;
        if (editObj.prizeJson) {
          this.form.prizeJson = JSON.parse(editObj.prizeJson);
        }
        if (editObj.themeUrl) {
          const attDataArr = [];
          attDataArr.push({
            url: editObj.themeUrl,
            dbUrl: editObj.themeUrl,
            name: getFileName(editObj.themeUrl)
          });
          this.form.themeUrl = attDataArr;
        }
      }
      if (!status) {
        this.form.id = 0;
        this.form.type = null;
        this.form.title = null;
        this.form.themeUrl = null;
        this.form.prizeJson = null;
        this.form.rule = null;
        this.$refs.form.resetFields();
      } else {
        this.getPrizesList();
      }
      this.dialogType = type;
      this.dialogFormVisible = status;
    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          const params = {
            type: form.type,
            title: form.title,
            rule: form.rule
          };
          if (form.themeUrl && form.themeUrl.length !== 0) {
            const urlArr = form.themeUrl.map(obj => obj["dbUrl"]);
            params.themeUrl = urlArr.join(",");
          }
          if (form.prizeJson) {
            params.prizeJson = JSON.stringify(form.prizeJson);
          }
          if (form.id && form.id !== 0) {
            params.id = form.id;
          }
          this.btnLoading = true;
          editRaffleActivity(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "themeUrl") {
        this.form.themeUrl = value;
      }
    },

    // 添加奖品
    addPrizes() {
      let data = this.form.prizeJson;
      data.push({
        id: null, // 奖品ID
        // num: null, // 奖品数量
        rate: null // 中奖概率
      });
      this.form.prizeJson = data;
    },
    /**
     *  查询奖品列表
     */
    getPrizesList() {
      const params = {
        page: 1,
        pageSize: 99
      };
      getPrizesList(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.prizesList = resp.data.entitys;
        }
      });
    },
    // 删除奖品
    deletePrizes(index) {
      this.form.prizeJson.splice(index, 1);
    },
    /**
     * 切换活动状态
     */
    checkActivityStatus(item) {
      const params = {
        id: item.id,
        status: item.status === 1 ? 2 : 1
      };
      updateRaffleActivityStatus(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.getList();
          this.$notify({
            title: "成功",
            message: "切换成功",
            type: "success",
            duration: 2000
          });
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.prizeJson_warp {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.content_warp {
  .uploadFile {
    width: 0;
    height: 0;
    display: none;
  }

  ::v-deep {
    .ql-container {
      min-height: 400px;
    }

    .ql-editor {
      min-height: 400px;
    }
  }
}

.total-container {
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #303133;
}
</style>
